import React from "react";
import { AppRoutes, ScrollToTopButton, Footer, Navbar } from "./components";
import { useScrollToTop } from "./hooks/useScrollToTop";

export const App = () => {
  useScrollToTop();

  return (
    <div className={"page"}>
      <Navbar />
      <main>
        <AppRoutes />
      </main>
      <ScrollToTopButton />
      <Footer />
    </div>
  );
};
